<div *ngIf="order" class="details-page-wrapper">
  <h2>Detalles del Pedido</h2>

  <div class="order-progress">
    <h2>Estado de tu pedido</h2>
    <div class="progress-container">
      <div
        class="progress-bar"
        [style.width]="calculateProgress(order?.status) + '%'">
      </div>
    </div>
    <div class="status-labels">
      <div *ngFor="let status of visibleStatusOrder" class="status-label">
        <span
          [ngClass]="{
            'active': order?.status && isActive(status),
            'completed': order?.status && isCompleted(status)
          }">
          {{ status }}
        </span>
      </div>
    </div>
  </div>

  <div class="info-card">
    <h3>Datos del pedido</h3>
    <p>
      <mat-icon>confirmation_number</mat-icon>
      Pedido ID: <span>{{ order?.id }}</span>
    </p>
    <p>
      <mat-icon>assignment</mat-icon>
      Estatus: <span>{{ order?.status }}</span>
    </p>
    <p>
      <mat-icon>delivery_dining</mat-icon>
      Fecha estimada de entrega:
      <strong>
        entre {{ order.createAtPlus5BusinessDays ? translateDate(order.createAtPlus5BusinessDays) : 'N/A' }} y
        {{ order.createAtPlus20BusinessDays ? translateDate(order.createAtPlus20BusinessDays) : 'N/A' }}
      </strong>
    </p>
  </div>

  <div class="info-card">
    <h3>Datos del cliente</h3>
    <p>
      <mat-icon>person</mat-icon>
      Nombre: <span>{{ order?.name }}</span>
    </p>
    <p>
      <mat-icon>email</mat-icon>
      Email: <span>{{ order?.email }}</span>
    </p>
    <p>
      <mat-icon>phone</mat-icon>
      Teléfono: <span>{{ order?.phone }}</span>
    </p>
    <p>
      <mat-icon>location_on</mat-icon>
      Dirección: <span>{{ order?.street }} {{ order?.numberHome }}, {{ order?.colony }}, {{ order?.city }}, {{ order?.state }}, {{ order?.zipCode }}, {{ order?.country }}</span>
    </p>
    <p>
      <mat-icon>event</mat-icon>
      Fecha de Creación: <span>{{ order?.createAt | date:'d MMMM yyyy' }}</span>
    </p>
  </div>

  <div class="info-card">
    <h3>Resumen de Envío</h3>
    <p>
      <mat-icon>local_shipping</mat-icon>
      Método de Envío: <span>{{ order?.shippingMethod }}</span>
    </p>
    <p>
      <mat-icon>emoji_transportation</mat-icon>
      Tipo de Envío: <span>{{ order?.shippingType }}</span>
    </p>
    <p>
      <mat-icon>monetization_on</mat-icon>
      Costo de Envío: <span>${{ order?.shippingCost | number:'1.2-2' }}</span>
    </p>
    <p class="shipping-info">
      Nombre de la paquetería: <span class="highlight">{{ order?.parcelName }}</span>
    </p>
    <p class="shipping-info">
      Número de Guía: <span class="highlight">{{ order?.guideNumber }}</span>
    </p>
  </div>

  <div class="info-card">
    <h3>Resumen de Pago</h3>
    <p>
      <mat-icon>payment</mat-icon>
      Total Pagado: <span class="amount">${{ order?.totalPayment | number:'1.2-2' }}</span>
    </p>
    <p>
      <mat-icon>shopping_cart</mat-icon>
      Subtotal: <span class="amount">${{ order?.subtotal | number:'1.2-2' }}</span>
    </p>
    <p>
      <mat-icon>local_shipping</mat-icon>
      Costo de envío: <span class="amount">${{ order?.shippingCost | number:'1.2-2' }}</span>
    </p>

    <p>
      <mat-icon>savings</mat-icon>
      Descuento: <span class="amount">${{ order?.discount | number:'1.2-2' }}</span>
    </p>
      
    <p>
      <mat-icon>confirmation_number</mat-icon>
      Cupón: <span class="amount">{{ order?.promoCodeApplied }}</span>
    </p>

  </div>

  <div class="info-card">
    <h3>Productos</h3>
    <div *ngFor="let product of order.products" class="product-card">
      <div class="product-content">
        <img [src]="product.coverImage" alt="{{ product.product }}">
        <div class="product-details">
          <h4>{{ product.product }} - {{ product.model }}</h4>
          <p>
            <mat-icon>style</mat-icon>
            Marca: <span>{{ product.brand }}</span>
          </p>
          <p>
            <mat-icon>category</mat-icon>
            Categoría: <span>{{ product.category }}</span>
          </p>
          <p>
            <mat-icon>layers</mat-icon>
            Subcategoría: <span>{{ product.subcategory }}</span>
          </p>
          <p>
            <mat-icon>palette</mat-icon>
            Color: <span>{{ product.selectedColor?.name || 'N/A' }}</span>
          </p>
          <p>
            <mat-icon>straighten</mat-icon>
            Talla: <span>{{ product.selectedSize?.size || 'N/A' }}</span>
          </p>
          <p>
            <mat-icon>attach_money</mat-icon>
            Precio: <span>${{ product.selectedSize?.price | number:'1.2-2' }}</span>
          </p>
          <p>
            <mat-icon>format_list_numbered</mat-icon>
            Cantidad: <span>{{ product.quantity }}</span>
          </p>
        </div>
      </div>
      <p *ngIf="product.personalized">
        <mat-icon>account_box</mat-icon>
        Personalización:
        <span *ngIf="product.selectedSize?.namePerson">Nombre: {{ product.selectedSize?.namePerson }}</span>
        <span *ngIf="product.selectedSize?.bloodType">, Tipo de sangre: {{ product.selectedSize?.bloodType }}</span>
        <span *ngIf="product.selectedSize?.position">, Cargo: {{ product.selectedSize?.position }}</span>
        <span *ngIf="product.selectedSize?.club">, Club: {{ product.selectedSize?.club }}</span>
        <span *ngIf="product.selectedSize?.yearsService">, Años de servicio: {{ product.selectedSize?.yearsService }}</span>
      </p>
      <p class="product-description" [innerHTML]="product.description"></p>
    </div>
  </div>

  <div class="info-card">
    <h3>Pagos</h3>
    <div *ngFor="let payment of order.pay" class="payment-card">
      <p>
        <mat-icon>credit_card</mat-icon>
        Método de Pago: <span>{{ payment.methodPay }}</span>
      </p>
      <p>
        <mat-icon>attach_money</mat-icon>
        Importe: <span>${{ payment.amount }}</span>
      </p>
      <p>
        <mat-icon>verified_user</mat-icon>
        Estado: <span>{{ payment.status }}</span>
      </p>
      <p>
        <mat-icon>description</mat-icon>
        Concepto: <span>{{ payment.concepto }}</span>
      </p>
      <p>
        <mat-icon>info</mat-icon>
        Descripción: <span>{{ payment.description }}</span>
      </p>
      <div *ngIf="payment.urlPay" class="payment-image-container">
        <img [src]="payment.urlPay" alt="Comprobante de Pago" />
      </div>
    </div>
  </div>

  <button mat-raised-button color="primary" (click)="regresar()" class="back-button">
    <mat-icon>arrow_back</mat-icon>
    Regresar a Pedidos
  </button>
</div>